import e from"./HierarchicalMenu.vue_vue&type=script&lang.js";import{render as r}from"./HierarchicalMenu.vue_vue&type=template&id=3548a9a1&lang.js";e.render=r;export default e;
//# sourceMappingURL=HierarchicalMenu.vue.js.map
